<template>
  <div
    ref="partialDiv"
    :asset-name="slug"
  >
    <section class="signup-success">
      <div
        :class="{
          'container mx-auto my-6': true,
        }"
      >
        <h2
          :class="{
            'signup-title': true,
          }"
        >
          {{ signupTitle }}
        </h2>

        <div
          :class="{
            'signup-msg success-msg mt-32px': true,
            'flex justify-center': true,
          }"
        >
          <div
            :class="{
              'w-[462px] rounded-md border border-[#dcdfeb] transition-all duration-300 ease-in-out hover:border-www-color-primary-lighter hover:shadow-card': true,
            }"
          >
            <div
              :class="{
                'card-body p-[25px]': true,
              }"
            >
              <ImageAtom
                v-if="image"
                v-bind="image"
                loading="eager"
              />

              <h3
                :class="{
                  'mt-6 text-center text-lg font-bold': true,
                }"
              >
                {{ cardTitle }}
              </h3>

              <p
                :class="{
                  email: true,
                  'text-center': true,
                }"
              >
                {{ emailValue }}
              </p>
            </div>
            <div
              :class="{
                'card-footer flex flex-col items-center border-t border-[#dcdfeb] bg-[#dcdfeb] bg-opacity-20 p-[15px] text-www-color-neutral-medium-dark': true,
              }"
            >
              <h6
                :class="{
                  'text-15px font-medium': true,
                }"
              >
                {{ cardSubtitle }}
              </h6>

              <ul
                :class="{
                  'list-disc px-6': true,
                }"
              >
                <template
                  v-for="(item, i) in signupMessageList"
                  :key="i"
                >
                  <li
                    :class="{
                      'link w-fit text-13px': true,
                    }"
                  >
                    <CodeEmbed v-bind="item" />
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <template v-if="screenPartialData?.sectionBuilder?.length > 0">
      <component
        :is="getComponent(component._type)"
        v-for="component in screenPartialData?.sectionBuilder"
        :key="component._key"
        :value="component"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import ImageAtom from '~/components/Atmos/ImageAtom/ImageAtom.vue';
import CodeEmbed from '~/components/Atmos/CodeEmbed/CodeEmbed.vue';
import type UnifiedSignupSessionInfo from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupSessionInfo';
import type EmailCheck422SignupScreen from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/screens/EmailCheck422SignupScreen';
import type { SignupPartialViewsSectionBuilder, UssMessage } from '~/sanity/types';
import UnifiedSignupStartScreen from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupStartScreen';
import AntiSpamUtil from '~/hekate-www/external/util/AntiSpamUtil';
import RedirectUtil from '~/hekate-www/external/util/RedirectUtil';
import { getComponent } from '~/components/Mapper';

const props = defineProps<
  UssMessage & {
    signupScreen: EmailCheck422SignupScreen;
    sessionInfo: UnifiedSignupSessionInfo;
    screenPartialData: SignupPartialViewsSectionBuilder;
  }
>();

const partialDiv = ref<HTMLDivElement | null>(null);
const { slug } = useRoute().params;

// Get email value from form field
const emailField = props.signupScreen.getField(FieldHtmlNameUtil.email);
const emailValue = computed(() => emailField.val as string);

onMounted(() => {
  // From initListeners: if buyStandard, redirect
  if (props.sessionInfo.startScreen.compareTo(UnifiedSignupStartScreen.buyStandard)) {
    partialDiv.value?.classList.add('d-none');
    RedirectUtil.redirectTo({
      delay: 0,
      target: props.signupScreen.getField(FieldHtmlNameUtil.signupRedirectUrl).val as string,
    });
    return;
  }
  // Otherwise run CSRF test
  AntiSpamUtil.csrfTokenTest({ hint: 'signup-422-screen' });
});
</script>
